// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__P0B6D","lightFooter":"Footer_lightFooter__hzvSU","darkFooter":"Footer_darkFooter__URr+6","footerLogo":"Footer_footerLogo__b42hs"};